module.exports = __webpack_public_path__ + "static/media/pegaso.75df9aa6.png";